import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { LayoutService } from 'app/core/http/services/layout.service';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { Encounter } from 'app/core/interfaces/encounter';

@Component({
  selector: 'page-schedule-edit-status',
  templateUrl: './schedule-edit-status.component.html',
  styleUrls: ['./schedule-edit-status.component.scss'],
})
export class ScheduleSecretaryEditStatusComponent implements OnInit {
  public status = '';
  public scheduleStatus: any[] = [
    { id: 'planned', text: 'Pendente', color: 'red', icon: 'error' },
    { id: 'finished', text: 'Confirmado', color: 'grey', icon: 'check_circle' },
    { id: 'in-progress', text: 'Em atendimento', color: 'orange', icon: 'pending' },
  ];

  public encounter!: Encounter;
  public errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    public layout: LayoutService,
    private encounterService: EncounterService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ngOnInit(): void {
    if (this.data.param.encounter) {
      this.encounter = this.data.param.encounter as Encounter;
      this.status = this.encounter.status;
    }
  }

  saveStatus() {
    this.errorMessage = '';
    if (this.status === 'in-progress' && this.encounter.status !== 'in-progress' && this.isOnlinePayment()) {
      this.errorMessage = 'A validação do código deve ser realizada pela organização.';
      return;
    }

    this.encounter.status = this.status;
    this.encounterService.updateNew(this.encounter.encounter_id!, this.encounter).subscribe({
      next: (encounter: Encounter) => this.dialogRef.close(encounter),
      error: (err) => console.log('error', err),
    });
  }

  isOnlinePayment(): boolean {
    return ['PIX', 'CREDIT_CARD'].includes((this.encounter?.paymentMethod || '').toUpperCase());
  }
}
